/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Deletecoursedesc2Inputs */

const zh_course_deletecoursedesc2 = /** @type {(inputs: Course_Deletecoursedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除课程将同时删除所有章节结构。已关联的学习资源不会被删除。`)
};

const en_course_deletecoursedesc2 = /** @type {(inputs: Course_Deletecoursedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting a course will remove all chapter structure. Linked study resources will not be deleted.`)
};

const es_course_deletecoursedesc2 = /** @type {(inputs: Course_Deletecoursedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar un curso eliminará toda la estructura de capítulos. Los recursos vinculados no se eliminarán.`)
};

/**
* | output |
* | --- |
* | "Deleting a course will remove all chapter structure. Linked study resources will not be deleted." |
*
* @param {Course_Deletecoursedesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_deletecoursedesc2 = /** @type {((inputs?: Course_Deletecoursedesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Deletecoursedesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_deletecoursedesc2(inputs)
	if (locale === "en") return en_course_deletecoursedesc2(inputs)
	return es_course_deletecoursedesc2(inputs)
});
export { course_deletecoursedesc2 as "course_deleteCourseDesc" }